import Image from '../../../../components/basic/Image';
import LinkHelper from '../../LinkHelper';
import AuthorNames from '../AuthorNames';
import TopicButtons from '../TopicButtons';

export default function ExploreMorePost({ locale, post }) {
  const title = post?.meta?.blogPostData?.postTitle || post?.wp?.title;

  return (
    <>
      {post?.meta?.blogPostData?._heroImageSrc ? (
        <div className="imagex mb-24 w-100% overflow-hidden">
          <LinkHelper
            className="text-grey-800 multiLine-draw"
            href={`/blog/${post.wp.slug}`}
            locale={locale}
          >
            <Image
              attributes={{
                className:
                  'transition-transform duration-300 group-hover:scale-105',
                mediaURL: post.meta.blogPostData._heroImageSrc,
                nonResponsive: true,
              }}
            />
          </LinkHelper>
        </div>
      ) : null}

      <TopicButtons theme="darkTan" topics={post.wp.categories} />

      {post?.wp?.slug && title ? (
        <p className="font-semibold font-body mb-16 mt-16 sm:text-22 xsx:leading-26 text-24 leading-30">
          <LinkHelper
            className="text-grey-800 multiLine-draw"
            href={`/blog/${post.wp.slug}`}
            locale={locale}
          >
            {title}
          </LinkHelper>
        </p>
      ) : null}

      <p className="font-medium text-16 text-grey-4">
        <AuthorNames authors={post?.meta?.blogPostData?._postAuthorsDetails} />
      </p>
    </>
  );
}
